import React from 'react';
import styled from 'styled-components';
import { Link } from '@reach/router';

import { blueColor, lightGrey1Color } from 'js/config/style';
import { url } from 'js/services/Network';

export const buttonSize = '3rem';

export default styled(props => (
  <div {...props}>
    <Link to={url('create-payment-link-page', { step: null })} title="Create payment link">
      +
    </Link>
  </div>
))`
  float: right;
  a {
    display: block;
    font-size: 2rem;
    line-height: 2rem;
    height: 2.5rem;
    width: ${buttonSize};
    text-align: center;
    color: ${blueColor};
    cursor: pointer;
    user-select: none;

    &:hover {
      background: ${lightGrey1Color};
      text-decoration: none;
    }

    &:active {
      background: ${lightGrey1Color.darken(0.1)};
    }
  }
`;
